/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as MarketplaceImport } from './routes/marketplace'
import { Route as BalancesImport } from './routes/balances'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as AuthCollectionUpdatePriceImport } from './routes/_auth/$collection/update-price'
import { Route as AuthCollectionNftsImport } from './routes/_auth/$collection/nfts'
import { Route as AuthCollectionMintNftImport } from './routes/_auth/$collection/mint-nft'
import { Route as AuthCollectionFileUploadImport } from './routes/_auth/$collection/file-upload'
import { Route as AuthCollectionCreateMetadataImport } from './routes/_auth/$collection/create-metadata'
import { Route as AuthCollectionBurnNftImport } from './routes/_auth/$collection/burn-nft'
import { Route as AuthCollectionNftsIndexImport } from './routes/_auth/$collection/nfts.index'
import { Route as AuthCollectionNftsTokenIdImport } from './routes/_auth/$collection/nfts_.$tokenId'

// Create/Update Routes

const MarketplaceRoute = MarketplaceImport.update({
  id: '/marketplace',
  path: '/marketplace',
  getParentRoute: () => rootRoute,
} as any)

const BalancesRoute = BalancesImport.update({
  id: '/balances',
  path: '/balances',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthCollectionUpdatePriceRoute = AuthCollectionUpdatePriceImport.update({
  id: '/$collection/update-price',
  path: '/$collection/update-price',
  getParentRoute: () => AuthRoute,
} as any)

const AuthCollectionNftsRoute = AuthCollectionNftsImport.update({
  id: '/$collection/nfts',
  path: '/$collection/nfts',
  getParentRoute: () => AuthRoute,
} as any)

const AuthCollectionMintNftRoute = AuthCollectionMintNftImport.update({
  id: '/$collection/mint-nft',
  path: '/$collection/mint-nft',
  getParentRoute: () => AuthRoute,
} as any)

const AuthCollectionFileUploadRoute = AuthCollectionFileUploadImport.update({
  id: '/$collection/file-upload',
  path: '/$collection/file-upload',
  getParentRoute: () => AuthRoute,
} as any)

const AuthCollectionCreateMetadataRoute =
  AuthCollectionCreateMetadataImport.update({
    id: '/$collection/create-metadata',
    path: '/$collection/create-metadata',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthCollectionBurnNftRoute = AuthCollectionBurnNftImport.update({
  id: '/$collection/burn-nft',
  path: '/$collection/burn-nft',
  getParentRoute: () => AuthRoute,
} as any)

const AuthCollectionNftsIndexRoute = AuthCollectionNftsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthCollectionNftsRoute,
} as any)

const AuthCollectionNftsTokenIdRoute = AuthCollectionNftsTokenIdImport.update({
  id: '/$collection/nfts_/$tokenId',
  path: '/$collection/nfts/$tokenId',
  getParentRoute: () => AuthRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/balances': {
      id: '/balances'
      path: '/balances'
      fullPath: '/balances'
      preLoaderRoute: typeof BalancesImport
      parentRoute: typeof rootRoute
    }
    '/marketplace': {
      id: '/marketplace'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof MarketplaceImport
      parentRoute: typeof rootRoute
    }
    '/_auth/$collection/burn-nft': {
      id: '/_auth/$collection/burn-nft'
      path: '/$collection/burn-nft'
      fullPath: '/$collection/burn-nft'
      preLoaderRoute: typeof AuthCollectionBurnNftImport
      parentRoute: typeof AuthImport
    }
    '/_auth/$collection/create-metadata': {
      id: '/_auth/$collection/create-metadata'
      path: '/$collection/create-metadata'
      fullPath: '/$collection/create-metadata'
      preLoaderRoute: typeof AuthCollectionCreateMetadataImport
      parentRoute: typeof AuthImport
    }
    '/_auth/$collection/file-upload': {
      id: '/_auth/$collection/file-upload'
      path: '/$collection/file-upload'
      fullPath: '/$collection/file-upload'
      preLoaderRoute: typeof AuthCollectionFileUploadImport
      parentRoute: typeof AuthImport
    }
    '/_auth/$collection/mint-nft': {
      id: '/_auth/$collection/mint-nft'
      path: '/$collection/mint-nft'
      fullPath: '/$collection/mint-nft'
      preLoaderRoute: typeof AuthCollectionMintNftImport
      parentRoute: typeof AuthImport
    }
    '/_auth/$collection/nfts': {
      id: '/_auth/$collection/nfts'
      path: '/$collection/nfts'
      fullPath: '/$collection/nfts'
      preLoaderRoute: typeof AuthCollectionNftsImport
      parentRoute: typeof AuthImport
    }
    '/_auth/$collection/update-price': {
      id: '/_auth/$collection/update-price'
      path: '/$collection/update-price'
      fullPath: '/$collection/update-price'
      preLoaderRoute: typeof AuthCollectionUpdatePriceImport
      parentRoute: typeof AuthImport
    }
    '/_auth/$collection/nfts_/$tokenId': {
      id: '/_auth/$collection/nfts_/$tokenId'
      path: '/$collection/nfts/$tokenId'
      fullPath: '/$collection/nfts/$tokenId'
      preLoaderRoute: typeof AuthCollectionNftsTokenIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/$collection/nfts/': {
      id: '/_auth/$collection/nfts/'
      path: '/'
      fullPath: '/$collection/nfts/'
      preLoaderRoute: typeof AuthCollectionNftsIndexImport
      parentRoute: typeof AuthCollectionNftsImport
    }
  }
}

// Create and export the route tree

interface AuthCollectionNftsRouteChildren {
  AuthCollectionNftsIndexRoute: typeof AuthCollectionNftsIndexRoute
}

const AuthCollectionNftsRouteChildren: AuthCollectionNftsRouteChildren = {
  AuthCollectionNftsIndexRoute: AuthCollectionNftsIndexRoute,
}

const AuthCollectionNftsRouteWithChildren =
  AuthCollectionNftsRoute._addFileChildren(AuthCollectionNftsRouteChildren)

interface AuthRouteChildren {
  AuthCollectionBurnNftRoute: typeof AuthCollectionBurnNftRoute
  AuthCollectionCreateMetadataRoute: typeof AuthCollectionCreateMetadataRoute
  AuthCollectionFileUploadRoute: typeof AuthCollectionFileUploadRoute
  AuthCollectionMintNftRoute: typeof AuthCollectionMintNftRoute
  AuthCollectionNftsRoute: typeof AuthCollectionNftsRouteWithChildren
  AuthCollectionUpdatePriceRoute: typeof AuthCollectionUpdatePriceRoute
  AuthCollectionNftsTokenIdRoute: typeof AuthCollectionNftsTokenIdRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCollectionBurnNftRoute: AuthCollectionBurnNftRoute,
  AuthCollectionCreateMetadataRoute: AuthCollectionCreateMetadataRoute,
  AuthCollectionFileUploadRoute: AuthCollectionFileUploadRoute,
  AuthCollectionMintNftRoute: AuthCollectionMintNftRoute,
  AuthCollectionNftsRoute: AuthCollectionNftsRouteWithChildren,
  AuthCollectionUpdatePriceRoute: AuthCollectionUpdatePriceRoute,
  AuthCollectionNftsTokenIdRoute: AuthCollectionNftsTokenIdRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/balances': typeof BalancesRoute
  '/marketplace': typeof MarketplaceRoute
  '/$collection/burn-nft': typeof AuthCollectionBurnNftRoute
  '/$collection/create-metadata': typeof AuthCollectionCreateMetadataRoute
  '/$collection/file-upload': typeof AuthCollectionFileUploadRoute
  '/$collection/mint-nft': typeof AuthCollectionMintNftRoute
  '/$collection/nfts': typeof AuthCollectionNftsRouteWithChildren
  '/$collection/update-price': typeof AuthCollectionUpdatePriceRoute
  '/$collection/nfts/$tokenId': typeof AuthCollectionNftsTokenIdRoute
  '/$collection/nfts/': typeof AuthCollectionNftsIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/balances': typeof BalancesRoute
  '/marketplace': typeof MarketplaceRoute
  '/$collection/burn-nft': typeof AuthCollectionBurnNftRoute
  '/$collection/create-metadata': typeof AuthCollectionCreateMetadataRoute
  '/$collection/file-upload': typeof AuthCollectionFileUploadRoute
  '/$collection/mint-nft': typeof AuthCollectionMintNftRoute
  '/$collection/update-price': typeof AuthCollectionUpdatePriceRoute
  '/$collection/nfts/$tokenId': typeof AuthCollectionNftsTokenIdRoute
  '/$collection/nfts': typeof AuthCollectionNftsIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/balances': typeof BalancesRoute
  '/marketplace': typeof MarketplaceRoute
  '/_auth/$collection/burn-nft': typeof AuthCollectionBurnNftRoute
  '/_auth/$collection/create-metadata': typeof AuthCollectionCreateMetadataRoute
  '/_auth/$collection/file-upload': typeof AuthCollectionFileUploadRoute
  '/_auth/$collection/mint-nft': typeof AuthCollectionMintNftRoute
  '/_auth/$collection/nfts': typeof AuthCollectionNftsRouteWithChildren
  '/_auth/$collection/update-price': typeof AuthCollectionUpdatePriceRoute
  '/_auth/$collection/nfts_/$tokenId': typeof AuthCollectionNftsTokenIdRoute
  '/_auth/$collection/nfts/': typeof AuthCollectionNftsIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/balances'
    | '/marketplace'
    | '/$collection/burn-nft'
    | '/$collection/create-metadata'
    | '/$collection/file-upload'
    | '/$collection/mint-nft'
    | '/$collection/nfts'
    | '/$collection/update-price'
    | '/$collection/nfts/$tokenId'
    | '/$collection/nfts/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/balances'
    | '/marketplace'
    | '/$collection/burn-nft'
    | '/$collection/create-metadata'
    | '/$collection/file-upload'
    | '/$collection/mint-nft'
    | '/$collection/update-price'
    | '/$collection/nfts/$tokenId'
    | '/$collection/nfts'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/balances'
    | '/marketplace'
    | '/_auth/$collection/burn-nft'
    | '/_auth/$collection/create-metadata'
    | '/_auth/$collection/file-upload'
    | '/_auth/$collection/mint-nft'
    | '/_auth/$collection/nfts'
    | '/_auth/$collection/update-price'
    | '/_auth/$collection/nfts_/$tokenId'
    | '/_auth/$collection/nfts/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  BalancesRoute: typeof BalancesRoute
  MarketplaceRoute: typeof MarketplaceRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  BalancesRoute: BalancesRoute,
  MarketplaceRoute: MarketplaceRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/balances",
        "/marketplace"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/$collection/burn-nft",
        "/_auth/$collection/create-metadata",
        "/_auth/$collection/file-upload",
        "/_auth/$collection/mint-nft",
        "/_auth/$collection/nfts",
        "/_auth/$collection/update-price",
        "/_auth/$collection/nfts_/$tokenId"
      ]
    },
    "/balances": {
      "filePath": "balances.tsx"
    },
    "/marketplace": {
      "filePath": "marketplace.tsx"
    },
    "/_auth/$collection/burn-nft": {
      "filePath": "_auth/$collection/burn-nft.tsx",
      "parent": "/_auth"
    },
    "/_auth/$collection/create-metadata": {
      "filePath": "_auth/$collection/create-metadata.tsx",
      "parent": "/_auth"
    },
    "/_auth/$collection/file-upload": {
      "filePath": "_auth/$collection/file-upload.tsx",
      "parent": "/_auth"
    },
    "/_auth/$collection/mint-nft": {
      "filePath": "_auth/$collection/mint-nft.tsx",
      "parent": "/_auth"
    },
    "/_auth/$collection/nfts": {
      "filePath": "_auth/$collection/nfts.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/$collection/nfts/"
      ]
    },
    "/_auth/$collection/update-price": {
      "filePath": "_auth/$collection/update-price.tsx",
      "parent": "/_auth"
    },
    "/_auth/$collection/nfts_/$tokenId": {
      "filePath": "_auth/$collection/nfts_.$tokenId.tsx",
      "parent": "/_auth"
    },
    "/_auth/$collection/nfts/": {
      "filePath": "_auth/$collection/nfts.index.tsx",
      "parent": "/_auth/$collection/nfts"
    }
  }
}
ROUTE_MANIFEST_END */
